import React, { useState, useEffect } from "react";
import { Button, Col, Descriptions, Divider, Form, InputNumber, Layout, Modal, Row, Table, Tag, Typography } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { inject, observer } from 'mobx-react'
import "./style.scss";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment-timezone";
import { cloneDeep } from "lodash";

const { Content } = Layout;
const { Text } = Typography;

const ViewAdmin = ({ userStore, voterStore }) => {

  const { Title } = Typography;
  const navigate = useNavigate()
  const [form] = Form.useForm();

  let { id } = useParams();

  useEffect(() => {

      userStore.page = 1;
      userStore.hasMore = false;
      userStore.perPage = 10;

      voterStore.page = 1;
      voterStore.hasMore = false;
      voterStore.perPage = 10;

      if(id){
        userStore.fetchUserByID(id);
        userStore.fetchUserLoadsTeamLeader(id);
        voterStore.fetchVoterAmountTeamLeaderByID(id);
      }
  }, [id]);

  const handlePrevPage = () => {
    userStore.page = userStore.page - 1;
    if(id){
      userStore.fetchUserLoadsTeamLeader(id);
    }
  };

  const handleNextPage = () => {
    userStore.page = userStore.page + 1;
    if(id){
      userStore.fetchUserLoadsTeamLeader(id);
    }
  };

  // FOR VOTERS AMOUNT
  const handlePrevPageVoters = () => {
    voterStore.page = voterStore.page - 1;
    if(id){
      voterStore.fetchVoterAmountTeamLeaderByID(id);
    }
  };

  const handleNextPageVoters = () => {
    voterStore.page = voterStore.page + 1;
    if(id){
      voterStore.fetchVoterAmountTeamLeaderByID(id);
    }
  };

  const columns = [
    {
      title: 'Type',
      dataIndex: 'Type',
      key: 'Type',
      render: (Type) => (
        <Tag color={'blue'}><Text type="primary" strong>{"Reloads ("+Type+")"}</Text></Tag>
      )
    },
    {
      title: 'Name',
      dataIndex: 'ItemName',
      key: 'ItemName',
      render: (ItemName) => (
        <Text type="primary" strong>{ItemName ? ItemName : "Cash"}</Text>
      )
    },
    {
      title: 'PPU',
      dataIndex: 'PricePerUnit',
      key: 'PricePerUnit',
      render: (PricePerUnit) => (
        <Text type="primary" strong>{PricePerUnit ? PricePerUnit : "-"}</Text>
      )
    },
    {
      title: 'Quantity',
      dataIndex: 'ReleasedQuantity',
      key: 'ReleasedQuantity',
      render: (ReleasedQuantity) => (
        <Text type="primary" strong>{ReleasedQuantity ? ReleasedQuantity : "-"}</Text>
      )
    },
    {
      title: 'Amount',
      key: 'Amount+VotersAmountID',
      dataIndex: 'Amount',
      responsive: ['lg', 'xl', 'md'],
      render: (Amount, record) => (
        <Text default strong>₱{formatNumber(Amount)}</Text>
      )
    },
    {
      title: 'Transaction Date',
      key: 'CreatedAt+UserLoadID',
      dataIndex: 'CreatedAt',
      responsive: ['lg', 'xl', 'md'],
      render: (CreatedAt) => (
        <Text default>{moment.utc(CreatedAt).format("MMM DD, YYYY")}</Text>
      )
    },
  ];

  const columnsVotersAmount = [
    {
      title: 'Type',
      dataIndex: 'Type',
      key: 'Type',
      render: (Type) => (
        <Tag color={'red'}><Text type="primary" strong>{"Distribute ("+Type+")"}</Text></Tag>
      )
    },
    {
      title: 'Name',
      dataIndex: 'ItemName',
      key: 'ItemName',
      render: (ItemName) => (
        <Text type="primary" strong>{ItemName ? ItemName : "Cash"}</Text>
      )
    },
    {
      title: 'PPU',
      dataIndex: 'PricePerUnit',
      key: 'PricePerUnit',
      render: (PricePerUnit) => (
        <Text type="primary" strong>{PricePerUnit ? PricePerUnit : "-"}</Text>
      )
    },
    {
      title: 'Quantity',
      dataIndex: 'Quantity',
      key: 'Quantity',
      render: (Quantity) => (
        <Text type="primary" strong>{Quantity ? Quantity : "-"}</Text>
      )
    },
    {
      title: 'Amount',
      key: 'Amount+VotersAmountID',
      dataIndex: 'Amount',
      responsive: ['lg', 'xl', 'md'],
      render: (Amount, record) => (
        <Text default strong>₱{formatNumber(Amount)}</Text>
      )
    },
    {
      title: 'Transaction Date',
      key: 'CreatedAt+VotersAmountID',
      dataIndex: 'CreatedAt',
      responsive: ['lg', 'xl', 'md'],
      render: (CreatedAt) => (
        <Text default>{moment.utc(CreatedAt).format("MMM DD, YYYY")}</Text>
      )
    },
  ];

  const formatNumber = (formatnumber) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(formatnumber);
  };

  return (
    <div className="view-admin-user">
      <Content>
        <div className="view-admin-user-content">
          <Title level={4}>Admin Details</Title>
          <Divider />
          <div className="information">
            <Descriptions column={{xs: 1, md: 2}} >
              {/* <Descriptions.Item label="User ID" span={1}>TL00001</Descriptions.Item> */}
              <Descriptions.Item label="Status" span={1}>
                <Tag
                  color={"green"}
                >
                  <Text type="primary" strong>{ (userStore.teamLeader &&  userStore.teamLeader.isActive) == 1 ? "ACTIVE" : "INACTIVE"}</Text>
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="Username" span={1}>{ userStore.teamLeader && userStore.teamLeader.username }</Descriptions.Item>
              <Descriptions.Item label="Create Date" span={1}>{ moment(userStore.teamLeader && userStore.teamLeader.createdAt).format("MMM DD, YYYY h:mm A") }</Descriptions.Item>
            </Descriptions>
            <Divider/>
            <Title level={5}>Basic Information</Title>
            <Descriptions column={2} bordered>
              <Descriptions.Item label="Name" span={1}>{ userStore.teamLeader && userStore.teamLeader.fullName }</Descriptions.Item>
              <Descriptions.Item label="Contact Number" span={1}>{ userStore.teamLeader && userStore.teamLeader.contactNumber }</Descriptions.Item>
              <Descriptions.Item label="Address" span={2}>{ userStore.teamLeader && userStore.teamLeader.address }</Descriptions.Item>
            </Descriptions>
            <Title level={5}>Budget Information</Title>
            <Descriptions column={2} bordered>
              <Descriptions.Item label="Total Budget Loaded" span={2}>
                <Tag
                  color={"blue"}
                >
                  <Text type="primary" strong>₱ { formatNumber(userStore.teamLeader && userStore.teamLeader.totalAmount) }</Text>
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="Total Used Budget" span={2}>
                <Tag
                  color={"red"}
                >
                  <Text type="primary" strong>₱ { formatNumber(userStore.teamLeader && userStore.teamLeader.totalAmountReload) }</Text>
                </Tag>
              </Descriptions.Item>
            </Descriptions>
            <Title level={5}>Budget History</Title>
            <Table pagination={false} columns={columns} dataSource={cloneDeep(userStore.userLoads)} bordered/>
            <ul className="pagination">
              <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={userStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
              <li className="pagination-item"><a>{userStore.page}</a></li>
              <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={userStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
            </ul>
            <Divider/>
            <Table pagination={false} columns={columnsVotersAmount} dataSource={cloneDeep(voterStore.votersAmounts)} bordered/>
            <ul className="pagination">
              <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPageVoters} disabled={voterStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
              <li className="pagination-item"><a>{voterStore.page}</a></li>
              <li className="pagination-next "><Button type="dashed" onClick={handleNextPageVoters} disabled={voterStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
            </ul>
          </div>
          <Divider/>
          <Row justify={'end'} gutter={10}>
            <Col>
              <Button onClick={() => navigate(-1)}>Back</Button>
            </Col>
          </Row>
        </div>
      </Content>
    </div>

  );
};

export default inject('userStore', 'voterStore')(observer(ViewAdmin));
